import * as z from "zod/v4";

const AccountMappingSchema_ = z.object({
  id: z.bigint(),
  connectionId: z.bigint(),
  mappingType: z.string(),
  externalAccountId: z.string(),
  accountName: z.string(),
  createdAt: z.date(),
});

export const getAccountMappings = {
  name: "getAccountMappings" as const,
  input: z.null(),
  output: z.object({ mappings: z.array(AccountMappingSchema_) }),
};
